import { RcFile } from 'antd/es/upload';

const mimeType = 'application/pdf';

export const checkMimeType = (data: RcFile) => {
  return {
    isPdf: data.type === mimeType,
  };
};
